import get from 'lodash/get';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import type { FeatureStatus } from '@jira/servicedesk__common/src/Enabled.tsx';
import type { FeaturesData, ServiceProjectFeature } from './FeaturesData.types.tsx';

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;

export const featuresResource: RouteResource<Partial<
	Record<
		ServiceProjectFeature,
		{
			status: FeatureStatus;
			editable: boolean;
		}
	>
> | null> = createResource<FeaturesData | null>({
	type: 'SERVICEDESK_FEATURES',
	getKey: ({ match, query }) =>
		// projectKey from url path or browse/{issueKey}
		getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0],
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-practice-features", jiraSpaEntry: "async-resource-servicedesk-practice-features" */ './GetDataFeaturesResource.tsx'
		),
	maxAge: ONE_DAY_IN_MILLIS,
});
